module.exports = __webpack_public_path__ + "767c7ac4189ebdbb7508afbb8c4c7533.png";